"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("@airasia/phoenix-components/components/Theme/constant");
var _constants = require("./constants");
var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    data: _propTypes.default.object.isRequired,
    customProperties: _propTypes.default.object,
    background: _propTypes.default.oneOf(_constant.ARR_BACKGROUND_COLORS),
    color: _propTypes.default.oneOf(_constant.ARR_COLORS),
    fontSize: _propTypes.default.oneOf(_constant.ARR_FONT_SIZE),
    viewport: _propTypes.default.oneOf(Object.keys(_constants.DEVICE_TYPE)),
    isChinaDomain: _propTypes.default.bool,
    idConfig: _propTypes.default.exact({
      parentName: _propTypes.default.string,
      widgetName: _propTypes.default.string,
      index: _propTypes.default.string
    }),
    excludeFooterNoteId: _propTypes.default.string
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    background: _constants.DEFAULT_STYLE.DEFAULT_BACKGROUND_COLOR,
    color: _constants.DEFAULT_STYLE.DEFAULT_TEXT_COLOR,
    fontSize: _constants.DEFAULT_STYLE.DEFAULT_FONT_SIZE,
    viewport: _constants.DEVICE_TYPE.desktop,
    isChinaDomain: false,
    excludeFooterNoteId: 'footerBottomLinks'
  }
};
exports.default = _default;